<div class="toolbar">
  <span>
    <button matButton="text" [disabled]="isBusy()" (click)="goBack()">
      <span>
        <mat-icon>keyboard_arrow_left</mat-icon>
        <label>Back</label>
      </span>
    </button>
  </span>
  <span class="spacer"></span>
  <span>
    <button matButton="text" (click)="save()">
      <span>
        <mat-icon>save</mat-icon>
        <label>Save</label>
      </span>
    </button>
  </span>
</div>
@if (errorMessage()) {
  <div class="errorMessage">
    <pre>{{ errorMessage() }}</pre>
  </div>
}
@if (userSelections() && selectedValues()) {
  <div class="body">
    <div class="selectionRow">
      <span class="selection">
        <label class='selectionLabel' for="systemType">System Type:</label>
        <select class='selectionInput' name="systemType" id="systemType"
          (change)="validateSelections('USSystemType', $event)"
          [class.invalid]="isInvalid('USSystemType')">
          <option value="" disabled="true">Please select</option>
          @for (selection of getSelections('USSystemType'); track selection) {
            <option [selected]="selection.Value === getCurrentValue('USSystemType')"
              [class.disabled]="!isSelectionValid('USSystemType', selection.Value)" [value]="selection.Value">
            {{ selection.Description }}</option>
          }
        </select>
      </span>
      <span class="selection">
        <label class='selectionLabel' for="riserAttachmentMethod">Riser Attachment Method</label>
        <select class='selectionInput' name="riserAttachmentMethod" id="riserAttachmentMethod"
          (change)="validateSelections('USRiserAttachmentMethod', $event)"
          [class.invalid]="isInvalid('USRiserAttachmentMethod')">
          <option value="" disabled="true">Please select</option>
          @for (selection of getSelections('USRiserAttachmentMethod'); track selection) {
            <option [selected]="selection.Value === getCurrentValue('USRiserAttachmentMethod')"
              [class.disabled]="!isSelectionValid('USRiserAttachmentMethod', selection.Value)"
            [value]="selection.Value">{{ selection.Description }}</option>
          }
        </select>
      </span>
    </div>
    <div class="selectionRow">
      <span class="selection">
        <label class='selectionLabel' for="riserVendorInput">Riser Supplier:</label>
        <select class='selectionInput' name="riserVendorInput" id="riserVendorInput"
          (change)="validateSelections('USRiserVendor', $event)"
          [class.invalid]="isInvalid('USRiserVendor')">
          <option value="" disabled="true">Please select</option>
          @for (selection of getSelections('USRiserVendor'); track selection) {
            <option [selected]="selection.Value === getCurrentValue('USRiserVendor')"
              [class.disabled]="!isSelectionValid('USRiserVendor', selection.Value)" [value]="selection.Value">
            {{ selection.Description }}</option>
          }
        </select>
      </span>
      <span class="selection">
        <label class='selectionLabel' for="bottomInsulationCutback">Riser Bottom Insulation Cutback:</label>
        <select class='selectionInput' name="bottomInsulationCutback" id="bottomInsulationCutback"
          (change)="validateSelections('USInsulationCutbackBottom', $event)"
          [class.invalid]="isInvalid('USInsulationCutbackBottom')">
          <option value="" disabled="true">Please select</option>
          @for (selection of getSelections('USInsulationCutbackBottom'); track selection) {
            <option [selected]="selection.Value === getCurrentValue('USInsulationCutbackBottom')"
              [class.disabled]="!isSelectionValid('USInsulationCutbackBottom', selection.Value)"
            [value]="selection.Value">{{ selection.Description }}</option>
          }
        </select>
      </span>
    </div>
    <div class="selectionRow">
      <span class="selection">
        <label class='selectionLabel' for="topInsulationCutback">Riser Top Insulation Cutback:</label>
        <select class='selectionInput' name="topInsulationCutback" id="topInsulationCutback"
          (change)="validateSelections('USInsulationCutbackTop', $event)"
          [class.invalid]="isInvalid('USInsulationCutbackTop')">
          <option value="" disabled="true">Please select</option>
          @for (selection of getSelections('USInsulationCutbackTop'); track selection) {
            <option [selected]="selection.Value === getCurrentValue('USInsulationCutbackTop')"
              [class.disabled]="!isSelectionValid('USInsulationCutbackTop', selection.Value)"
            [value]="selection.Value">{{ selection.Description }}</option>
          }
        </select>
      </span>
      <span class="selection">
        <label class='selectionLabel' for="endTreatment">Riser End Treatment:</label>
        <select class='selectionInput' name="endTreatment" id="endTreatment"
          (change)="validateSelections('USEndTreatment', $event)"
          [class.invalid]="isInvalid('USEndTreatment')">
          <option value="" disabled="true">Please select</option>
          @for (selection of getSelections('USEndTreatment'); track selection) {
            <option [selected]="selection.Value === getCurrentValue('USEndTreatment')"
              [class.disabled]="!isSelectionValid('USEndTreatment', selection.Value)" [value]="selection.Value">
            {{ selection.Description }}</option>
          }
        </select>
      </span>
    </div>
    <div class="selectionRow">
      <span class="selection">
        <label class='selectionLabel' for="topStandoff">Riser Connection Height:</label>
        <select class='selectionInput' name="topStandoff" id="topStandoff"
          (change)="validateSelections('USTopStandoff', $event)"
          [class.invalid]="isInvalid('USTopStandoff')">
          <option value="" disabled="true">Please select</option>
          @for (selection of getSelections('USTopStandoff'); track selection) {
            <option [selected]="selection.Value === getCurrentValue('USTopStandoff')"
              [class.disabled]="!isSelectionValid('USTopStandoff', selection.Value)" [value]="selection.Value">
            {{ selection.Description }}</option>
          }
        </select>
      </span>
    </div>
    <div class="selectionRow">
      <div class="selectionHeader">Cold Water Riser Options</div>
      <span class="selection">
        <label class='selectionLabel' for="coldCopperType">Cold Water Copper Type:</label>
        <select class='selectionInput' name="coldCopperType" id="coldCopperType"
          (change)="validateSelections('USColdRiserCopperType', $event)"
          [class.invalid]="isInvalid('USColdRiserCopperType')">
          <option value="" disabled="true">Please select</option>
          @for (selection of getSelections('USColdRiserCopperType'); track selection) {
            <option [selected]="selection.Value === getCurrentValue('USColdRiserCopperType')"
              [class.disabled]="!isSelectionValid('USColdRiserCopperType', selection.Value)"
            [value]="selection.Value">{{ selection.Description }}</option>
          }
        </select>
      </span>
      <span class="selection">
        <label class='selectionLabel' for="coldSupplyInsulation">Cold Supply Insulation:</label>
        <select class='selectionInput' name="coldSupplyInsulation" id="coldSupplyInsulation"
          (change)="validateSelections('USCSInsulationThickness', $event)"
          [class.invalid]="isInvalid('USCSInsulationThickness')">
          <option value="" disabled="true">Please select</option>
          @for (selection of getSelections('USCSInsulationThickness'); track selection) {
            <option [selected]="selection.Value === getCurrentValue('USCSInsulationThickness')"
              [class.disabled]="!isSelectionValid('USCSInsulationThickness', selection.Value)"
            [value]="selection.Value">{{ selection.Description }}</option>
          }
        </select>
      </span>
    </div>
    <div class="selectionRow">
      <span class="selection">
        <label class='selectionLabel' for="coldReturnInsulation">Cold Return Insulation:</label>
        <select class='selectionInput' name="coldReturnInsulation" id="coldReturnInsulation"
          (change)="validateSelections('USCRInsulationThickness', $event)"
          [class.invalid]="isInvalid('USCRInsulationThickness')">
          <option value="" disabled="true">Please select</option>
          @for (selection of getSelections('USCRInsulationThickness'); track selection) {
            <option [selected]="selection.Value === getCurrentValue('USCRInsulationThickness')"
              [class.disabled]="!isSelectionValid('USCRInsulationThickness', selection.Value)"
            [value]="selection.Value">{{ selection.Description }}</option>
          }
        </select>
      </span>
    </div>
    <div class="selectionRow">
      <div class="selectionHeader">Drain Riser Options</div>
      <span class="selection">
        <label class='selectionLabel' for="drainCopperType">Drain Riser Copper Type:</label>
        <select class='selectionInput' name="drainCopperType" id="drainCopperType"
          (change)="validateSelections('USDRRiserCopperType', $event)"
          [class.invalid]="isInvalid('USDRRiserCopperType')">
          <option value="" disabled="true">Please select</option>
          @for (selection of getSelections('USDRRiserCopperType'); track selection) {
            <option [selected]="selection.Value === getCurrentValue('USDRRiserCopperType')"
              [class.disabled]="!isSelectionValid('USDRRiserCopperType', selection.Value)"
            [value]="selection.Value">{{ selection.Description }}</option>
          }
        </select>
      </span>
      <span class="selection">
        <label class='selectionLabel' for="drainInsulation">Drain Insulation Thickness:</label>
        <select class='selectionInput' name="drainInsulation" id="drainInsulation"
          (change)="validateSelections('USDRInsulationThickness', $event)"
          [class.invalid]="isInvalid('USDRInsulationThickness')">
          <option value="" disabled="true">Please select</option>
          @for (selection of getSelections('USDRInsulationThickness'); track selection) {
            <option [selected]="selection.Value === getCurrentValue('USDRInsulationThickness')"
              [class.disabled]="!isSelectionValid('USDRInsulationThickness', selection.Value)"
            [value]="selection.Value">{{ selection.Description }}</option>
          }
        </select>
      </span>
    </div>
    <div class="selectionRow">
      <div class="selectionHeader">Hot Water Riser Options</div>
      <span class="selection">
        <label class='selectionLabel' for="hotCopperType">Hot Water Copper Type:</label>
        <select class='selectionInput' name="hotCopperType" id="hotCopperType"
          (change)="validateSelections('USHotRiserCopperType', $event)"
          [class.invalid]="isInvalid('USHotRiserCopperType')">
          <option value="" disabled="true">Please select</option>
          @for (selection of getSelections('USHotRiserCopperType'); track selection) {
            <option [selected]="selection.Value === getCurrentValue('USHotRiserCopperType')"
              [class.disabled]="!isSelectionValid('USHotRiserCopperType', selection.Value)"
            [value]="selection.Value">{{ selection.Description }}</option>
          }
        </select>
      </span>
      <span class="selection">
        <label class='selectionLabel' for="hotSupplyInsulation">Hot Supply Insulation:</label>
        <select class='selectionInput' name="hotSupplyInsulation" id="hotSupplyInsulation"
          (change)="validateSelections('USHSInsulationThickness', $event)"
          [class.invalid]="isInvalid('USHSInsulationThickness')">
          <option value="" disabled="true">Please select</option>
          @for (selection of getSelections('USHSInsulationThickness'); track selection) {
            <option [selected]="selection.Value === getCurrentValue('USHSInsulationThickness')"
              [class.disabled]="!isSelectionValid('USHSInsulationThickness', selection.Value)"
            [value]="selection.Value">{{ selection.Description }}</option>
          }
        </select>
      </span>
    </div>
    <div class="selectionRow">
      <span class="selection">
        <label class='selectionLabel' for="hotReturnInsulation">Hot Return Insulation:</label>
        <select class='selectionInput' name="hotReturnInsulation" id="hotReturnInsulation"
          (change)="validateSelections('USHRInsulationThickness', $event)"
          [class.invalid]="isInvalid('USHRInsulationThickness')">
          <option value="" disabled="true">Please select</option>
          @for (selection of getSelections('USHRInsulationThickness'); track selection) {
            <option [selected]="selection.Value === getCurrentValue('USHRInsulationThickness')"
              [class.disabled]="!isSelectionValid('USHRInsulationThickness', selection.Value)"
            [value]="selection.Value">{{ selection.Description }}</option>
          }
        </select>
      </span>
    </div>
  </div>
}
@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <label class="busyLabel">Please Wait...</label>
    </div>
  </div>
}
